<template>
  <div class="app-container">
    <div class="info-box">
      <div class="left-box" v-if="!isMB">
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有部门</span>
          <el-button type="text" @click="createTree" icon="el-icon-circle-plus-outline" v-if="$permission.canWrite()"></el-button>
        </div>
        <div class="left-main">
          <org-tree ref="orgTree" @on-select="onSelect"></org-tree>
        </div>
      </div>
      <div class="main-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button
              :disabled="data.DpId==null"
               
              type="primary"
              @click="create"
              icon="el-icon-plus"
            >添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="80" v-if="$permission.canWrite()">
              <template slot-scope="{row}">
                <el-button type="text" @click="editById(row.EmpId)">编辑</el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              label="操作"
              fixed="right"
              align="center"
              :width="$store.state.isMB?50:100"
            >
              <template slot-scope="{row}">
                <el-button type="text" @click="detailsById(row.EmpId)">查看</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="toReload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/schoolmanage/org/list";
import editDialog from "@/components/schoolmanage/org/editDialog";
import orgTree from "@/components/schoolmanage/org/orgTree/tree";

export default {
  name: "org",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    orgTree,
  },
  data() {
    return {
      data: {
        DpId: null,
        DpName: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    // this.$refs.orgTree.getData();
  },
  methods: {
    toReload() {
      this.$refs.orgTree.getData();
      this.reload()
    },
    allData() {
      this.data.DpId = 0;
      this.resetSelect();
      this.$refs.list.getData({});
      console.log("allData", this.data);
    },
    resetSelect() {
      this.$refs.orgTree.resetSelect();
      this.data.DpId = 0;
      this.data.DpName = "";
    },
    onSelect(data) {
      console.log("onSelect", data);
      if (this.data.DpId != data.DpId) {
        this.data.DpId = data.DpId;
        this.data.DpName = data.DpName;
        this.$refs.list.getData({ DpId:data.DpId });
      }
    },
    createTree() {
      this.$refs.orgTree.create();
    },
    create() {
      this.$refs.editDialog.openCreate(this.data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.EmpId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.left-box {
  width: 250px;
  min-width: 250px;
  border: 1px solid #e4e7ed;
  .left-title {
    padding-left: 25px;
    color: #606266;
    background-color: #ebeef5;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    line-height: 40px;
    padding-right: 8px;
    .el-button--text {
      font-size: 18px;
    }
  }
  .left-main {
    height: calc(100% - 40px);
    overflow: auto;
  }
}
.main-box {
  width: 100%;
  margin-left: 10px;
  padding: 10px;
  border: 1px solid #e4e7ed;
  overflow: auto;
}
.el-form-item {
  margin-bottom: 0;
}
.footer {
  border-top: 1px solid #e4e7ed;
  padding: 10px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 50px 20px 0px 20px;
  @media screen and (max-width: 480px) {
    margin-top: 10px;
  }
  .el-button {
    width: 80px;
  }
}
.image-slot {
  font-size: 36px;
  color: #909399;
  position: absolute;
  top: 50%;
  left: 50%;
  /* 这里有兼容性问题 */
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.avatar {
  height: 100%;
  display: block;
}
</style>